(() => {
  const replacements = [
    [new RegExp('\\bMy\\s+Store\\b', 'g'), 'Monroevale'],
    [/\bMonroe Vale\b/g, 'Monroevale'],
    [/\bMonroeVale\b/g, 'Monroevale'],
    [/\bMonroe vale\b/g, 'Monroevale']
  ];

  const cleanText = (value) => replacements.reduce((text, [pattern, replacement]) => text.replace(pattern, replacement), value);

  const cleanVisibleText = () => {
    const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        const parent = node.parentElement;
        if (!parent || ['SCRIPT', 'STYLE', 'NOSCRIPT', 'TEXTAREA'].includes(parent.tagName)) return NodeFilter.FILTER_REJECT;
        return replacements.some(([pattern]) => pattern.test(node.nodeValue)) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
      }
    });
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach((node) => { node.nodeValue = cleanText(node.nodeValue); });
    if (document.title) document.title = cleanText(document.title);
  };

  const init = () => {
    document.documentElement.classList.add('mv-has-js');
    cleanVisibleText();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();

